import { styled } from "@material-ui/core";
import { motion } from "framer-motion";

export const CustomWrapper = styled(motion.div)(({ theme }) => ({
  margin: "0 auto",
  width: "250px",
  height: "150px",
  background: theme.palette.common.white,
  borderRadius: "8px",
  overflow: "hidden",
  filter: "drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.1))",
  cursor: "pointer",
  "-webkit-tap-highlight-color": "rgba(255, 255, 255, 0)",
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  alignItems: "center"
}));

export const CustomVideo = styled("video")(({ theme }) => ({
  width: "250px",
  height: "116px",
  background: theme.palette.common.white,
  objectFit: "cover",
  objectPosition: "center"
}));
